// Como se pinta el Markdown de las respuestas del Brain.
//
// Portado del prototipo (`dont-merge-front-vision`): reconoce sus marcas
// propias dentro del codigo en linea -`tag:nombre:color`, `doc:...`- y las
// convierte en chips en vez de dejarlas como texto.

import React from 'react'
import { TagChip } from './TagChip'
import { ItemChip } from './ItemChip'

/** Como se lee una respuesta del Brain. **En un solo sitio**: estaba escrito a
 *  mano en el mensaje del chat, y el resultado de un encargo es la misma
 *  respuesta -asi que copiarlo dejaba dos listas de treinta clases que nadie
 *  iba a mantener iguales-. */
export const PROSE_BRAIN =
  'prose prose-sm max-w-none leading-[1.85] dark:prose-invert prose-headings:mb-3 prose-headings:mt-5 prose-headings:first:mt-0 prose-p:mb-3.5 prose-p:last:mb-0 prose-a:text-primary prose-a:no-underline prose-blockquote:my-4 prose-blockquote:border-l-primary/40 prose-blockquote:bg-primary/5 prose-blockquote:py-1 prose-blockquote:not-italic prose-strong:text-foreground prose-code:rounded-md prose-code:bg-muted prose-code:px-1 prose-code:py-0.5 prose-code:text-xs prose-ol:mb-3.5 prose-ol:mt-2 prose-ul:mb-3.5 prose-ul:mt-2 prose-li:mb-1.5 prose-li:ml-1 prose-table:text-sm prose-th:px-4 prose-th:py-2.5 prose-th:text-left prose-td:px-4 prose-td:py-3.5 prose-hr:my-5 prose-code:before:content-none prose-code:after:content-none hover:prose-a:underline'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mdComponents: Record<string, React.ComponentType<any>> = {
  code({ children, className, ...props }: { children?: React.ReactNode; className?: string;[k: string]: unknown }) {
    const text = String(children || '')
    if (!className) {
      // Tag chips: `tag:name:color`
      if (text.startsWith('tag:')) {
        const parts = text.split(':')
        if (parts.length >= 3) return <TagChip name={parts[1]} color={parts[2]} />
      }
      // Item chips: `doc:name`, `url:name`, `lead:name`
      if (text.startsWith('doc:')) return <ItemChip type="doc" name={text.slice(4)} />
      if (text.startsWith('url:')) return <ItemChip type="url" name={text.slice(4)} />
      if (text.startsWith('lead:')) return <ItemChip type="lead" name={text.slice(5)} />
    }
    return <code className={className} {...props}>{children}</code>
  },
  // Tables can be wide — let them scroll horizontally instead of overflowing
  // the chat column on narrow screens.
  table({ children, ...props }: { children?: React.ReactNode;[k: string]: unknown }) {
    return (
      <div className="-mx-1 my-4 overflow-x-auto first:mt-0">
        <table {...props}>{children}</table>
      </div>
    )
  },
}

/* ─── Chat Input ────────────────────────────────────────── */

/* ─── Agent selector popover ─────────────────────────────── */
